module.exports = __webpack_public_path__ + "img/about_img5.4947a534.png";